import { Button, PaperPanel } from "@scribenote/brian-design-system";
import { useState } from "react";

import { useNewBuild } from "./deployedBuild";

const POLL_MS = 5 * 60_000;

/** Staff may be mid-recording or mid-edit, so this asks rather than reloading. */
export const NewBuildNotice = () => {
  const { newBuild } = useNewBuild(POLL_MS);
  const [dismissed, setDismissed] = useState<string>();

  if (!newBuild || dismissed === newBuild) return null;

  return (
    <PaperPanel
      className="w-80 max-w-[calc(100vw-2rem)] p-4 shadow-lg"
      data-testid="new-build-notice"
    >
      <div role="status" className="space-y-1">
        <p className="font-medium">A new version of Brian is available</p>
        <p className="text-sm text-annotation">
          Refresh when you’re at a good stopping point.
        </p>
      </div>
      <div className="mt-3 flex gap-2">
        <Button size="sm" onClick={() => window.location.reload()}>
          Refresh
        </Button>
        <Button
          size="sm"
          variant="ghost"
          onClick={() => setDismissed(newBuild)}
        >
          Dismiss
        </Button>
      </div>
    </PaperPanel>
  );
};
